<template>
  <div class="notificationDetails">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <div class="detailsBanner">
      <ol class="breadNav clearfix ">
        <li class="pull-left"><a @click="back">消息通知</a></li>
        <li class="pull-left active">消息详情页</li>
      </ol>
    </div>
    <div class="detailCon">
      <div class="detailsTit">
        <h4>{{noticeInfo.title}}</h4>
        <p class="updateTime">更新时间：{{noticeInfo.createTime|time}}</p>
      </div>
      <div class="detailsConBox">
        <p v-html="noticeInfo.content"></p>
      </div>
    </div>
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      return {
        hitSearchUrl:'',
        noticeInfo:{},
        navigationColumnInfos:[],
        webConfigInfo:{},
        footerColumnInfos:[],
        noticeId:'',
        attachementDtos:[],
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        title:'',
        updateTime:'',
        content:'',
        noticeId:'',
        noticeInfo:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      let query = this.$route.query;
      this.noticeId = query.noticeId;
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainMessageCommonInfo?noticeId='+this.noticeId, {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.verrifyCodeUrl = this.data.verrifyCodeUrl;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        this.noticeInfo = this.data.notifyVo;
      }).catch((err) => {
        console.log(err)
      })
      
    },
    methods: {
      jump(url){
        window.location.href = url;
      },
      back(){
        this.$router.go(-1);//返回上一层
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/messageNotificationDetails/index.vue